import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { ListServerPaginationStateModel, LoadDataFacade, SetInitialStateFacade } from '../../../../../common/models';
import { MasterDataType } from '../constants';
import { MasterDataReportItemModel, MasterDataReportListSearchCriteria } from '../models';
import {
  MasterDataReportItemInitialState,
  MasterDataReportItemListLoad,
  MasterDataReportItemSetInitialData,
} from './master-data-report-item.actions';
import { MasterDataReportItemState } from './master-data-report-item.state';

@Injectable({ providedIn: 'root' })
export class MasterDataReportItemFacade implements LoadDataFacade, SetInitialStateFacade {
  listDto$: Observable<ListServerPaginationStateModel<MasterDataReportItemModel>> = this.store.select(
    MasterDataReportItemState.getList,
  );
  loaded$: Observable<boolean> = this.store.select(MasterDataReportItemState.getLoaded);
  type$: Observable<MasterDataType> = this.store.select(MasterDataReportItemState.getType);

  constructor(private store: Store) {}

  loadAll(filter: MasterDataReportListSearchCriteria): void {
    this.store.dispatch(new MasterDataReportItemListLoad(filter));
  }

  setReportInitData(id: string, type: MasterDataType): void {
    this.store.dispatch(new MasterDataReportItemSetInitialData({ id, type }));
  }

  setInitialState(): void {
    this.store.dispatch(new MasterDataReportItemInitialState());
  }
}
